export const getTimeStringFromTimestamp = (time: number) => {
  return `${new Date(time).getHours()}:${eventTimeMinutes(time)}`;
};

const eventTimeMinutes = (time: number) => {
  return new Date(time).getMinutes() === 0
    ? '00'
    : new Date(time).getMinutes() < 10
    ? `0${new Date(time).getMinutes()}`
    : new Date(time).getMinutes();
};
